// extracted by mini-css-extract-plugin
module.exports = {"container":"text-overplay-play-bar_container_1V3"};